module.exports = __webpack_public_path__ + "assets/394df36d0301ed5d01c007ba5fd93215.mp3";